$(function () {
    search_trigger = $('.header__search-button');
    search_container = $('.header__search-form');

    search_trigger.click(function () {
        $(this).toggleClass('header__search-button--active');
        search_container.toggleClass('header__search-form--active');
    });

    $('#siteSearch').bind('keypress', function (e) {
        if (e.keyCode == 13) {
            e.preventDefault();
            doSearch();
        }
    });

});

function doSearch() {
    document.location.href = '/search-results/?q=' + $('#siteSearch').val();
}

// $(function () {
//     $('ul .dropDownAction').click(function (event) {
//         event.preventDefault();

//         var menuItem = $(this).parent();
//         if (menuItem.hasClass('active')) {
//             menuItem.removeClass('active');
//         } else {
//             menuItem.addClass('active');
//         }


//     });

//     $('#siteSearch').bind('keypress', function (e) {
//         if (e.keyCode == 13) {
//             e.preventDefault();
//             doSearch();
//         }
//     });

// });

// function doSearch() {
//     document.location.href = '/search-results/?q=' + $('#siteSearch').val();
// }